(() => {
  if (!customElements.get('np-product-tabs')) {
    customElements.define('np-product-tabs', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        const tabs = [...this.querySelectorAll('[data-np-tab]')];
        const panels = [...this.querySelectorAll('[data-np-panel]')];
        this.querySelector('[data-np-tablist]').setAttribute('role', 'tablist');
        const activate = (target, focus = false) => {
          tabs.forEach(tab => {
            const selected = tab === target;
            tab.setAttribute('aria-selected', String(selected));
            tab.tabIndex = selected ? 0 : -1;
          });
          panels.forEach(panel => { panel.hidden = panel.id !== target.dataset.npTab; });
          if (focus) target.focus();
        };
        tabs.forEach((tab, index) => {
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', tab.dataset.npTab);
          const panel = panels.find(item => item.id === tab.dataset.npTab);
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', tab.id);
          panel.tabIndex = 0;
          tab.addEventListener('click', () => activate(tab));
          tab.addEventListener('keydown', event => {
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
            if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = tabs.length - 1;
            if (next !== undefined) { event.preventDefault(); activate(tabs[next], true); }
          });
        });
        activate(tabs[0]);
      }
    });
  }
  document.addEventListener('click', event => {
    const sizeLink = event.target.closest('[data-np-open-size]');
    if (sizeLink) {
      const dialog = document.getElementById(sizeLink.dataset.npOpenSize);
      if (dialog && typeof dialog.showModal === 'function') {
        event.preventDefault();
        dialog.showModal();
      }
    }
    const unit = event.target.closest('[data-np-unit]');
    if (unit) {
      const dialog = unit.closest('dialog');
      const cm = unit.dataset.npUnit === 'cm';
      dialog.querySelectorAll('[data-np-inches]').forEach(cell => {
        cell.textContent = cm ? (Number(cell.dataset.npInches) * 2.54).toFixed(1) : cell.dataset.npInches;
      });
      dialog.querySelector('[data-np-unit-label]').textContent = cm ? 'centimetres' : 'inches';
      dialog.querySelectorAll('[data-np-unit]').forEach(button => button.setAttribute('aria-pressed', String(button === unit)));
    }
    if (event.target.matches('dialog.np-size-dialog')) {
      const bounds = event.target.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) event.target.close();
    }
    const backLink = event.target.closest('[data-np-back-to-design]');
    if (backLink) {
      const design = document.querySelector('.product__info-container');
      if (design) { event.preventDefault(); design.scrollIntoView({ behavior: 'auto', block: 'start' }); }
    }
  });
})();
